/* jshint esversion: 6 */
/* jshint esversion: 8 */
import { initializeApp } from "firebase/app";
import { getAuth } from 'firebase/auth';
import { getFirestore } from 'firebase/firestore';
import { getDatabase } from 'firebase/database';
import { getMessaging, getToken } from 'firebase/messaging';

const firebaseConfig = {
  apiKey: "AIzaSyAUAQs6r8yRv9fFXqkckeXif8xr9_hbVaw",
  authDomain: "goevent-5943a.firebaseapp.com",
  databaseURL: "https://goevent-5943a-default-rtdb.firebaseio.com",
  projectId: "goevent-5943a",
  storageBucket: "goevent-5943a.firebasestorage.app",
  messagingSenderId: "602457680426",
  appId: "1:602457680426:web:e98cf094eef8da3f30b153",
  measurementId: "G-GVD1JGR529"
};

const app = initializeApp(firebaseConfig);

const db = getFirestore(app);
const auth = getAuth(app);
const database = getDatabase(app);

const vapidKey = "BGIyBdshIYDeD1X40mtmAYiUvfyWpo2HcHrqrYJ0j5xLyqOanTIv11x49K60bOKEfpd0vbQuvQniORYLGjrhqR8";
const messaging = getMessaging(app);

export const RecvestToken = async () => {
  return Notification.requestPermission()
    .then((permission) => {
      if (permission === "granted") {
        const Token = getToken(messaging, { vapidKey });
        return Token;
      }
    });
};

export { db, auth, database };